import { render } from "./ColleagueRegistration.vue?vue&type=template&id=56758d68&scoped=true"
import script from "./ColleagueRegistration.vue?vue&type=script&lang=js"
export * from "./ColleagueRegistration.vue?vue&type=script&lang=js"

import "./ColleagueRegistration.vue?vue&type=style&index=0&id=56758d68&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56758d68"]])

export default __exports__